import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { GbInfiniteScrollComponent } from './gb-infinite-scroll/gb-infinite-scroll.component'

@NgModule({
  imports: [CommonModule],
  declarations: [GbInfiniteScrollComponent],
  exports: [GbInfiniteScrollComponent],
})
export class GbSharedUtilsInfiniteScrollModule {}
